// 未翻译
export default {
  pageTitle: '保证金缴纳记录',
  titleText: '保证金缴纳记录',
  titleOptBtnText: '提交保证金缴纳',
  direction: {
    all: '所有',
    unconfirmed: '未确认',
    confirmed: '已确认'
  },
  unconfirmed: '未确认',
  confirmed: '已确认',
  // model
  platformReceivingAccount: '平台收款账号',
  paidAmount: '缴纳金额',
  paidAmountTips: '请按照100的倍数进行提交',
  currencyUnit: '货币单位',
  transactionSerialNumber: '交易流水号',
  transactionSerialNumberTips: '请输入银行转帐流水号或其它交易流水凭证',
  transferAccount: '转账账号信息',
  transferAccountPlaceholder: '请包含帐户名  帐户号  以及银行或支付方式  如：李四    工商银行  6453543533553453',
  tipsTitle: '提示',
  tips1: '1. 提交后不能更改，请确认信息无误后再执行提交',
  tips2: '2. 请先进行转帐缴纳后再提交，平台确认收款后将保证金更新到店铺保证金余额',
  submitText: '提交',
  modelTitleText: '提交保证金缴纳',

  okTips: '提交后不能更改，请确认信息无误',
  // search
  submitTime: '提交缴纳日期',
  transferTime: '转帐日期',
  paymentId: '缴纳ID',
  platformConfirmationStatus: '平台确认状态',
  searchBtnText: '查询',
  resetBtnText: '重置',
  paymentDate: '缴纳日期',
  // tb columns
  tbColumns: {
    id: '提交ID',
    storeId: '店铺ID',
    transferDate: '转帐日期',
    paidAmount: '交纳金额',
    currency: '单位',
    statusText: '状态',
    confirmedAt: '确认时间',
    platformReceivingAccountInfo: '平台收款帐号',
    transferAccountInfo: '转款帐号',
    transactionSerialNumber: '交易流水号'
  },

  cancelText: '取消',
  okText: '确认'
}
